import {Controller} from "@hotwired/stimulus";
import Debug from 'debug';
const debug = Debug('app:nav')

export const name = "nav";


export default class extends Controller<HTMLBodyElement> {
    static targets = ["link"];

    declare linkTargets: HTMLAnchorElement[];


    connect() {
        this.update();
        document.addEventListener("turbo:load", this.update);
    }

    disconnect() {
        document.removeEventListener("turbo:load", this.update);
    }

    linkTargetConnected() {
        debug('link target connected');
        this.update();
    }

    linkTargetDisconnected(element: HTMLAnchorElement) {
        debug('link target disconnected');
        element.removeAttribute("aria-current");
    }

    update = () => {
        if (!this.linkTargets?.length) {
            return;
        }

        const currentPath = this.normalizePath(window.location.pathname);

        this.linkTargets.forEach((link) => {
            const linkPath = this.extractPath(link);

            if (!linkPath) {
                link.removeAttribute("aria-current");
                return;
            }

            const isActive = this.matchesPath(currentPath, linkPath);

            if (isActive) {
                link.setAttribute("aria-current", "page");
            } else {
                link.removeAttribute("aria-current");
            }
        });
    };

    private extractPath(link: HTMLAnchorElement): string | null {
        const href = link.getAttribute("href");

        if (!href || href.startsWith("#") || href.startsWith("javascript:")) {
            return null;
        }

        try {
            const url = href.startsWith("http") ? new URL(href) : new URL(href, window.location.origin);

            if (url.origin !== window.location.origin) {
                return null;
            }

            return this.normalizePath(url.pathname);
        } catch {
            return null;
        }
    }

    private normalizePath(pathname: string | null | undefined): string {
        if (!pathname) {
            return "/";
        }

        let normalized = pathname.startsWith("/") ? pathname : `/${pathname}`;

        if (normalized.length > 1 && normalized.endsWith("/")) {
            normalized = normalized.slice(0, -1);
        }

        return normalized;
    }

    private matchesPath(currentPath: string, targetPath: string): boolean {
        if (targetPath === "/") {
            return currentPath === "/";
        }

        return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);
    }
}
